export const ANSWERS_DATA = {
  code01: {
    answer: "TOMORROW",

    next: {
      route: "/answer",
      DateVal: "code01",
      titImgClass: "answerTit",
      counting: true,
    },
  },
  time02: {
    answer: ["18", "18회"],

    next: {
      route: "/answer",
      DateVal: "time02",
      titImgClass: "answerTit",
      counting: true,
    },
  },
  time03: {
    answer: ["A", "회의실"],

    next: {
      route: "/answer",
      DateVal: "time03",
      titImgClass: "answerTit",
      counting: true,
    },
  },
  trace4: {
    answer: "네일아트샵",

    next: {
      route: "/answer",
      DateVal: "trace4",
      titImgClass: "answerTit",
      counting: true,
    },
  },
  mind05: {
    answer: ["25", "10월 25일", "10.25", "10/25"],

    next: {
      route: "/answer",
      DateVal: "mind05",
      titImgClass: "answerTit",
      counting: true,
    },
  },
  file06: {
    answer: ["45", "45분"],

    next: {
      route: "/answer",
      DateVal: "file06",
      titImgClass: "answerTit",
      counting: true,
    },
  },
  lang07: {
    answer: [
      "19:45",
      "7시45분",
      "19시45분",
      "7:45",
      "오후 7시45분",
      "1945",
      "745",
    ],

    next: {
      route: "/answer",
      DateVal: "lang07",
      titImgClass: "answerTit",
      counting: true,
    },
  },
  alarm8: {
    answer: "박진호",

    next: {
      route: "/answer",
      DateVal: "alarm8",
      titImgClass: "answerTit",
      counting: true,
    },
  },
  cross9: {
    answer: ["B", "용의자B", "용의자 B"],

    next: {
      route: "/answer",
      DateVal: "cross9",
      titImgClass: "answerTit",
      counting: true,
    },
  },
  end_q1: {
    answer: "2",

    next: {
      route: "/quiz",
      answerData: "end_q2",
      DateVal: "end_q2",
      titImgClass: "quizTit10",
      hintWhetherIs: false,
      hintContent: "",
    },
  },
  end_q2: {
    answer: "3",

    next: {
      route: "/quiz",
      answerData: "end_q3",
      DateVal: "end_q3",
      titImgClass: "quizTit10",
      hintWhetherIs: false,
      hintContent: "",
    },
  },
  end_q3: {
    answer: "5",

    next: {
      route: "/quiz",
      answerData: "end_q4",
      DateVal: "end_q4",
      titImgClass: "quizTit10",
      hintWhetherIs: false,
      hintContent: "",
    },
  },
  end_q4: {
    answer: "2",

    next: {
      route: "/quiz",
      answerData: "end_q5",
      DateVal: "end_q5",
      titImgClass: "quizTit10",
      hintWhetherIs: false,
      hintContent: "",
    },
  },
  end_q5: {
    answer: "2",

    next: {
      route: "/quiz",
      answerData: "end_q6",
      DateVal: "end_q6",
      titImgClass: "quizTit10",
      hintWhetherIs: false,
      hintContent: "",
    },
  },
  end_q6: {
    answer: "2",

    next: {
      route: "/quiz",
      answerData: "last_q",
      DateVal: "last_q",
      titImgClass: "quizTit10",
      hintWhetherIs: false,
      hintContent: "",
    },
  },
  last_q: {
    answer: ["B", "이지은", "B.이지은", "B 이지은"],

    next: {
      route: "/answer",
      DateVal: "last_answer",
      titImgClass: "answerTit2",
      counting: true,
    },
  },
};
